import { render, staticRenderFns } from "./unassigned.vue?vue&type=template&id=13bf83a4&"
import script from "./unassigned.vue?vue&type=script&lang=js&"
export * from "./unassigned.vue?vue&type=script&lang=js&"
import style0 from "./unassigned.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports